// extracted by mini-css-extract-plugin
export default {"Rectangle":"drawing-item_Rectangle__dXDw9","SingleResizer":"drawing-item_SingleResizer__tdOZx"};